import React, { useState } from 'react';
import { dataUser } from '../Helpers/util';
import './css/wallet-dashboard.css';
import BankDetailImg from './img/bank-detail-img.svg';
import Sidebar from "../Layout/Sidebar";
import CustomHeader from "../Layout/Header";


import { Layout } from "antd";

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function BankDetails() {
  const [collapsed, setCollapsed] = useState(true);

  function generateConstantValue(companyId) {
    let constantValue = 'STS00700';

    if (companyId < 10) {
      constantValue += '000' + companyId;
    } else if (companyId < 100) {
      constantValue += '00' + companyId;
    } else if (companyId < 1000) {
      constantValue += '0' + companyId;
    } else {
      constantValue += companyId;
    }

    return constantValue;
  }

  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

  return (
    <>

      <Layout>

        <Sidebar collapsed={collapsed} />

        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


        <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
          <div className="PageContent">
            <div className="BankDetail_Page">
              <div className="row">
                <div className="col-md-5">
                  <div className="BankDetailContainer">
                    <div className='SwSubHeading'>
                      <h3>Bank details</h3>
                    </div>
                    <div className="BankDetailBox">
                      <div className="text-center my-4">
                        <img src={BankDetailImg} />
                      </div>
                      <div className="BankDetail_Row">
                        <div className="BankDetail_Label">Bank Name</div>
                        <div className="BankDetail_Data">ICICI Bank Ltd</div>
                      </div>
                      <div className="BankDetail_Row">
                        <div className="BankDetail_Label">Account Number</div>
                        <div className="BankDetail_Data">
                          {generateConstantValue(UserObj.company_id)}
                        </div>
                      </div>
                      {/* <div className='BankDetail_Row'>
                                    <div className='BankDetail_Label'>Account Holder Name</div>
                                    <div className='BankDetail_Data'>Smartworks Tech Solutions Private Limited</div>
                                </div> */}
                      <div className="BankDetail_Row">
                        <div className="BankDetail_Label">IFSC Code</div>
                        <div className="BankDetail_Data">ICIC0000106</div>
                      </div>
                      <div className="BankDetail_Row">
                        <div className="BankDetail_Label">Account Currency</div>
                        <div className="BankDetail_Data">INR</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="Bank_GuidelineContainer">
                    <div className='SwSubHeading'> <h3>Important Guidelines</h3></div>

                    <div className="GuidelineBox">
                      <ul className='SwList SwList--bullet'>
                        <li>
                          <span>
                            Fund transfers can be through any channels by using the
                            above account details within India.
                          </span>
                        </li>
                        <li>
                          <span>
                            All funds transferred will be reflected in your INR
                            account. Supported fund transfer methods include bank
                            tranfer using IMPS, NEFT, RTGS and UPI.
                          </span>{' '}
                        </li>
                        <li>
                          <span>
                            UPI id can be used to send and receive payments via this
                            platform.
                          </span>{' '}
                        </li>
                        <li>
                          <span>
                            The per transaction limit for IMPS and NEFT is 5 lacs
                            and 10 lacs respectively.
                          </span>{' '}
                        </li>
                        <li>
                          <span>
                            RTGS payment can be done during the working hours only,
                            having lower transaction limit of 2 lacs and upper limit
                            per transaction is of 5 crore.
                          </span>
                        </li>
                        <li>
                          <span>
                            Fund settlement timelines depend upon the method of fund
                            transfer.
                          </span>
                        </li>
                        <li>
                          <span>
                            Company wallet will be auto credited with points (1
                            point = 1 INR) once we receive fund settlement, which
                            can be further distributed to employees.
                          </span>
                        </li>
                        <li>
                          <span>
                            Please contact your account manager if you've any
                            further queries.{' '}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </Layout>

      </Layout>
    </>
  );
}
export default BankDetails;
